import React from 'react';
import Layout from '@/components/Layout/Layout';
import ChurchSteepleHero from '@/components/ChurchSteeple/ChurchSteepleHero';
import ChurchSteepleIntroduction from '@/components/ChurchSteeple/ChurchSteepleIntroduction';
import ChurchSteepleServices from '@/components/ChurchSteeple/ChurchSteepleServices';
import ChurchSteepleProcess from '@/components/ChurchSteeple/ChurchSteepleProcess';
import ChurchSteepleCommonIssues from '@/components/ChurchSteeple/ChurchSteepleCommonIssues';
import ChurchSteepleFAQ from '@/components/ChurchSteeple/ChurchSteepleFAQ';
import { Helmet } from 'react-helmet-async';

const ProfessionalChurchSteepleRepairRaleighNC = () => {
  return (
    <>
      <Helmet>
        <title>Professional Church Steeple Repair and Replacement Services in Raleigh NC and Surrounding Areas | Carolina Trophy Roofs</title>
        <meta name="description" content="Expert church steeple repair and replacement services in Raleigh, NC and surrounding areas. Professional steeple restoration, maintenance, and emergency repairs. Licensed contractors serving churches throughout the Triangle area." />
        <meta name="keywords" content="church steeple repair Raleigh NC, steeple replacement Raleigh, church steeple restoration, steeple maintenance Triangle area, church steeple contractors NC" />
        <link rel="canonical" href="https://carolinatrophyroofs.com/professional-church-steeple-repair-and-replacement-services-in-raleigh-nc-and-surrounding-areas" />
      </Helmet>
      <Layout>
        <div className="w-full">
          <ChurchSteepleHero />
          <ChurchSteepleIntroduction />
          <ChurchSteepleServices />
          <ChurchSteepleProcess />
          <ChurchSteepleCommonIssues />
          <ChurchSteepleFAQ />
        </div>
      </Layout>
    </>
  );
};

export default ProfessionalChurchSteepleRepairRaleighNC;